import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Form, Input, Button, message, Result } from 'antd'
import { tokens } from '../theme/tokens'
import './Auth.css'

export default function SetPassword() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()
  const [msg, contextHolder] = message.useMessage()
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  if (!token) {
    return (
      <div className="auth-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: tokens.colors.background }}>
        <Result status="error" title="无效的邀请链接" subTitle="链接缺少必要参数，请联系管理员重新发送邀请。" />
      </div>
    )
  }

  if (success) {
    return (
      <div className="auth-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: tokens.colors.background }}>
        <Result
          status="success"
          title="密码设置成功"
          subTitle="您现在可以使用新密码登录系统。"
          extra={<Button type="primary" onClick={() => navigate('/login', { replace: true })}>前往登录</Button>}
        />
      </div>
    )
  }

  const onFinish = async (values: { password: string }) => {
    setLoading(true)
    try {
      const res = await fetch('/api/auth/accept-invite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password: values.password }),
      })
      if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: '设置失败' }))
        throw new Error(err.detail)
      }
      setSuccess(true)
    } catch (e: any) {
      msg.error(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page" style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: '100vh', background: tokens.colors.background,
    }}>
      {contextHolder}
      <div className="auth-card" style={{
        width: 400, padding: 40,
        background: tokens.colors.surface,
        borderRadius: tokens.radius.xl,
        border: `1px solid ${tokens.colors.border}`,
        boxShadow: tokens.shadows.card,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{
            fontSize: 28, fontWeight: 700, margin: 0,
            background: tokens.gradients.heading,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            ApexTribe
          </h1>
          <p style={{ color: tokens.colors.textMuted, marginTop: 8 }}>
            设置您的登录密码
          </p>
        </div>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="password"
            label="新密码"
            rules={[{ required: true, message: '请输入密码' }, { min: 6, message: '密码至少6位' }]}
          >
            <Input.Password size="large" placeholder="请输入新密码" />
          </Form.Item>
          <Form.Item
            name="confirm"
            label="确认密码"
            dependencies={['password']}
            rules={[
              { required: true, message: '请确认密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) return Promise.resolve()
                  return Promise.reject(new Error('两次密码不一致'))
                },
              }),
            ]}
          >
            <Input.Password size="large" placeholder="请再次输入密码" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              设置密码
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
